import React, { FunctionComponent } from 'react'
import { useT } from '@transifex/react'
import { vn } from 'vend-number'
import { ERRORS } from '../../../../constants/sale-form-errors'
import { LineItem } from '../../../../models/line-item'
import { InputErrorMessage } from './InputErrorMessage'

interface Props {
  lineItem: LineItem
  error: string | null
}

export const LineItemSplitQuantityError: FunctionComponent<Props> = ({
  lineItem,
  error,
}) => {
  const t = useT()

  if (!error) return null

  let errorMessage: string | null = null

  if (error === ERRORS.INVALID_MIN) {
    errorMessage = t('Enter a positive number', {
      _context: 'Error message when the input is not a positive number',
    })
  }

  if (error === ERRORS.INVALID_MAX) {
    if (vn(lineItem.quantity).lessThan(0)) {
      errorMessage = t('Must be less than the return’s absolute value', {
        _context:
          'Error message when the input is greater than the absolute value of the return',
      })
    } else {
      errorMessage = t('Must be less than the line item quantity', {
        _context:
          'Error message when the input is greater than the line item quantity',
      })
    }
  }

  if (error === ERRORS.INVALID_CHARACTERS) {
    errorMessage = t('Enter a numeric value', {
      _context: 'Error message when the input contains non-numeric characters',
    })
  }

  return errorMessage ? (
    <InputErrorMessage errorElement={<>{errorMessage}</>} />
  ) : null
}
